var map = {
	"./avatar.jpg": "IIfh",
	"./emojis": "EzSH",
	"./emojis.json": "EzSH",
	"./file/文件_Excel.png": "Mlq5",
	"./file/文件_MP3.png": "nnrx",
	"./file/文件_avi.png": "n7/v",
	"./file/文件_pdf.png": "7I/7",
	"./file/文件_ppt.png": "AEzW",
	"./file/文件_txt.png": "UgoW",
	"./file/文件_world.png": "LNWu",
	"./file/文件_zip.png": "SdJU",
	"./file/文件_未知.png": "kVIX",
	"./kayi-logo-white.png": "jacJ",
	"./kayi-logo.png": "njxU",
	"./logo.png": "/KAl",
	"./声音-black.png": "NFKd",
	"./声音-white.png": "LT7w",
	"./女士.png": "1p2g",
	"./客户群组.png": "+gOZ",
	"./文件.png": "wXAQ",
	"./未知.png": "9+DW",
	"./消息.png": "V2Z6",
	"./消息提示音.mp3": "Ut2Y",
	"./男士.png": "3f3o"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "iNTJ";


//////////////////
// WEBPACK FOOTER
// ./packages/assets ^\.\/.*$
// module id = iNTJ
// module chunks = 0